import paymentAccountActionTypes from '../actions/payment-accounts-action-types';

const initialState = {
  paymentAccounts: [],
  showDialog: false,
  accountIdForUpdate: '',
  defaultPayment: '',
  paymentAcct: undefined,
  error: false,
  selectedPaymentAccount: {},
  paymentAccountsFetchComplete: false,
  lastCreatedPaymentAccount: null

};
export const paymentAccounts = (state = initialState, action) => {
  switch (action.type) {
    case paymentAccountActionTypes.SET_PAYMENT_ACCOUNTS_WITH_PRIMARY: {
      const { paymentAccounts, primaryPaymentAcct } = action.payload;
      const temp = paymentAccounts.filter(acct => acct.id !== primaryPaymentAcct.id);
      const paymentAccountsWithDefaultFirst = [primaryPaymentAcct, ...temp];
      return {
        ...state,
        paymentAccounts: paymentAccountsWithDefaultFirst,
        defaultPayment: primaryPaymentAcct.id,
        selectedPaymentAccount: primaryPaymentAcct,
        paymentAccountsFetchComplete: true

      };
    }
    case paymentAccountActionTypes.SET_PAYMENT_ACCOUNTS: {
      const { paymentAccounts } = action.payload;
      return { ...state, paymentAccounts,paymentAccountsFetchComplete: true };
    }
    case paymentAccountActionTypes.REMOVE_PAYMENT_ACCOUNT: {
      const paymentAccounts = state.paymentAccounts.filter(account => account.id !== action.deletedAccountId);
      return { ...state, paymentAccounts}
    }
    case paymentAccountActionTypes.TOGGLE_PAYMENT_ACCOUNT_DIALOG:
      return { ...state, showDialog: true, ...action.payload };
    case paymentAccountActionTypes.HIDE_PAYMENT_ACCOUNT_DIALOG:
      return { ...state, showDialog: false, accountIdForUpdate: '', paymentAcct: undefined };
    case paymentAccountActionTypes.PAYMENT_ACCOUNTS_ERROR:
      return { ...state, error: true };
    case paymentAccountActionTypes.SET_DEFAULT_PAYMENT_AND_UPDATE: {
      const temp = state.paymentAccounts.filter(acct => acct.id !== action.defaultPayment.id);
      const paymentAccountsWithDefaultFirst = [action.defaultPayment, ...temp];
      return {...state, defaultPayment: action.defaultPayment.id, paymentAccounts: paymentAccountsWithDefaultFirst};
    }
    case paymentAccountActionTypes.SET_DEFAULT_PAYMENT:
      return { ...state, defaultPayment: action.defaultPayment };
    case paymentAccountActionTypes.ADD_NEW_PAYMENT_ACCOUNT:
      return { ...state, paymentAccounts: [...state.paymentAccounts, action.newPaymentAccount], lastCreatedPaymentAccount: action.newPaymentAccount};
    case paymentAccountActionTypes.SET_SELECTED_PAYMENT_ACCOUNT:
      return { ...state, selectedPaymentAccount: action.selectedPaymentAccount };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/account/reducers/payment-accounts-reducer.js